module.exports = __webpack_public_path__ + "static/media/06.9aefa342.mp3";